import { ReactNode } from 'react';
import { useLingui } from '@lingui/react';
import { AVAILABLE_LOCALES, AvailableLocale, switchLocale } from '@/lib/localization';
import { cn } from '@/lib/utils';
import { ProsumoLogo } from '@/common/components/prosumo-logo/ProsumoLogo';

export interface AuthLayoutProps {
  children: ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  const { i18n } = useLingui();
  const currentLocale = i18n.locale as AvailableLocale;

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-gray-50 p-4 sm:p-6 lg:p-8">
      <div className="absolute right-4 top-4 flex items-center gap-0.5 rounded-lg bg-white p-1 ring-1 ring-black/5">
        {AVAILABLE_LOCALES.map((locale) => (
          <button
            key={locale}
            onClick={() => switchLocale(locale)}
            className={cn(
              'rounded-md px-3 py-1 text-xs font-semibold transition-colors',
              locale === currentLocale
                ? 'bg-blue-600 text-white'
                : 'text-gray-500 hover:text-gray-800'
            )}
          >
            {locale.toUpperCase()}
          </button>
        ))}
      </div>

      <div className="mb-8 flex justify-center">
        <ProsumoLogo />
      </div>

      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5 sm:p-10">
        {children}
      </div>
    </div>
  );
};
